export enum E_ERROR {
  LOGIN_FAIL = 'LOGIN_FAIL',
  REGISTER_FAIL = 'REGISTER_FAIL',
  NO_VENTE_WITH_THIS_ID = 'Error_869',
  NO_ENCAISSEMENT_WITH_THIS_ID = 'Error_870',
  NO_CLIENT_WITH_THIS_ID = 'Error_871',
  NO_BIEN_WITH_THIS_ID = 'Error_872',
  NO_USER_WITH_THIS_ID = 'Error_873',
  NO_PROJECT_WITH_THIS_ID = 'Error_874',
  NO_BULLETIN_WITH_THIS_ID = 'Error_874',
  NO_ACTION = 'Error_ACTION',
}
